let consumer;
export async function getConsumer() {
  if (consumer) return consumer;
  const _await$import = await import("@rails/actioncable/src"),
    createConsumer = _await$import.createConsumer;
  return setConsumer(createConsumer());
}
export function setConsumer(newConsumer) {
  return consumer = newConsumer;
}
export async function subscribeTo(channel, mixin) {
  const _await$getConsumer = await getConsumer(),
    subscriptions = _await$getConsumer.subscriptions;
  return subscriptions.create(channel, mixin);
}